import React from 'react';
// import styled from 'styled-components'

// const SvgContainer = styled.svg`
//   width: 1.45em;
//   height: 1.45em;
//   padding-top: 10px;
//   .cls-1 {
//     fill: none;
//     stroke: #2d2d2d;
//     stroke-linejoin: round;
//     stroke-width: 2px;
//   }
// `

const StatisticsUnderline = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M28 26H5C4.45 26 4 25.55 4 25V4H6V24H28V26Z" fill="#2d2d2d"/>
			<path d="M26 22H22C21.45 22 21 21.55 21 21V13C21 12.45 21.45 12 22 12H26C26.55 12 27 12.45 27 13V21C27 21.55 26.55 22 26 22ZM23 20H25V14H23V20Z" fill="#2d2d2d"/>
			<path d="M19 22H15C14.45 22 14 21.55 14 21V8C14 7.45 14.45 7 15 7H19C19.55 7 20 7.45 20 8V21C20 21.55 19.55 22 19 22ZM16 20H18V9H16V20Z" fill="#2d2d2d"/>
			<path d="M12 22H8C7.45 22 7 21.55 7 21V15C7 14.45 7.45 14 8 14H12C12.55 14 13 14.45 13 15V21C13 21.55 12.55 22 12 22ZM9 20H11V16H9V20Z" fill="#2d2d2d"/>
			<path d="M28 30H4V32H28V30Z" fill="#2d2d2d"/>
		</svg>

	);
};

export default StatisticsUnderline;
